import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';

import ByDestinationView from './ByDestination.view';

import { FormValidationObject } from 'app/models/general';
import { DestinationForm } from './ByDestination.model';

interface Props {
  className?: string;
  passengers: number;
  returnDateVisibility: boolean;
  initialValues?: DestinationForm | null;
  onSubmit?: (values: DestinationForm) => void;
}

const ByDestination: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const addressValidation = yup
    .object({
      name: yup.string().required(),
      lat: yup.number().nullable().required(),
      lng: yup.number().nullable().required(),
    })
    .required();

  const form = useFormik<DestinationForm>({
    initialValues: {
      from: null,
      to: null,
      date: null,
      returnDate: null,
      pax: props.passengers,
    },
    validationSchema: yup.object<FormValidationObject<keyof DestinationForm>>({
      from: addressValidation,
      to: addressValidation,
      date: yup.object().required(),
      returnDate: yup.object().nullable(),
      pax: yup.number().min(1).required(),
    }),
    onSubmit(values: DestinationForm) {
      props.onSubmit?.(values);
    },
  });

  useEffect(() => {
    form.setFieldValue('pax', props.passengers);
  }, [props.passengers, form.setFieldValue]);

  useEffect(() => {
    if (props.initialValues) {
      form.setValues(() => {
        return {
          from: props.initialValues!.from,
          to: props.initialValues!.to,
          date: props.initialValues!.date,
          returnDate: props.initialValues!.returnDate || null,
          pax: props.initialValues!.pax,
        };
      });
    }
  }, [props.initialValues, form.setValues]);


  return (
    <ByDestinationView
      className={props.className}
      form={form}
      returnDateVisibility={props.returnDateVisibility}
    ></ByDestinationView>
  );
};

ByDestination.displayName = 'ByDestination';
ByDestination.defaultProps = {};

export default ByDestination;
